import React, { useEffect, useState } from "react";
import { isBrowser } from "react-device-detect";
import DatePicker from "react-modern-calendar-datepicker";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import LargeModal from "../../../../components/modals/LargeModal";
import { addSamplingData } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
import {
  sampling_home_care_default_data,
  sampling_times,
} from "./../../../../config/sampling";
import { closeHomeCareOrderSamplingModal } from "./../../../../redux/actions/modals";
const HomeCareSamplingComponent = () => {
  const dispatch = useDispatch();
  const [selectedDay, setSelectedDay] = useState(null);
  const [samplingData, setSamplingData] = useState({});
  const { sampling_home_care_order_open, sampling_home_care_order } =
    useSelector((state) => state.modals);
  const { add_sampling_data_waiting } = useSelector((state) => state.orders);
  useEffect(() => {
    setSamplingData(sampling_home_care_default_data);
  }, []);
  const updateSamplingData = (key, value) => {
    let current = samplingData;
    current[key]["value"] = value;
    setSamplingData(current);
  };
  const submitSamplingData = () => {
    let errors = [];
    if (samplingData.sampling_date.value.trim() === "") {
      errors.push("تعیین تاریخ پزشک/پرستار الزامی است");
    }
    if (samplingData.sampling_from_hour.value.trim() === "") {
      errors.push("تعیین بازه اعزام پزشک/پرستار الزامی است");
    }
    if (samplingData.sampling_to_hour.value.trim() === "") {
      errors.push("تعیین بازه اعزام پزشک/پرستار الزامی است");
    }

    if (samplingData.sampler_name.value.trim() === "") {
      errors.push("تعیین نام پزشک/پرستار الزامی است");
    }

    if (samplingData.sampler_contact_phone.value.trim() === "") {
      errors.push("تعیین شماره هماهنگی پزشک/پرستار الزامی است");
    }
    if (errors.length > 0) {
      errors.forEach((error) => {
        toaster.error(error);
      });
      return;
    }
    let body = {
      id: sampling_home_care_order.id,
      data: samplingData,
    };
    dispatch(addSamplingData(body));
  };
  return (
    <LargeModal
      header="تعیین زمان اعزام پزشک/پرستار"
      show={sampling_home_care_order_open}
      className={isBrowser ? "" : "homecare-desired-time-modal"}
      closeFunction={closeHomeCareOrderSamplingModal}
    >
      <div className="lab-sampling-form-holder">
        <div className="form-holder">
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">تاریخ اعزام</label>
            <div className="col-sm-10">
              <DatePicker
                value={selectedDay}
                onChange={(data) => {
                  setSelectedDay(data);
                  updateSamplingData(
                    "sampling_date",
                    data.year + "/" + data.month + "/" + data.day
                  );
                }}
                inputPlaceholder="تعیین زمان اعزام"
                shouldHighlightWeekends
                locale="fa"
                style={{ width: "100%" }}
                id="sampling-date"
              />
            </div>
          </div>
          {/* <Row> */}
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">بازه زمانی</label>
            <div className="time-range-homecare">
              <div className="col-sm-6 col-xs-6">
                <div className="custome-homecare-select">
                  <select
                    className="form-control"
                    onChange={(sampling_from_hour) => {
                      updateSamplingData(
                        "sampling_from_hour",
                        sampling_from_hour.target.value
                      );
                    }}
                  >
                    <option value="">از ساعت</option>
                    {sampling_times.map((value, index) => {
                      return (
                        <option key={index} value={value.value}>
                          {value.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-sm-6 col-xs-6">
                <div className="custome-homecare-select">
                  <select
                    className="form-control"
                    onChange={(sampling_to_hour) => {
                      updateSamplingData(
                        "sampling_to_hour",
                        sampling_to_hour.target.value
                      );
                    }}
                  >
                    <option value="">تا ساعت</option>
                    {sampling_times.map((value, index) => {
                      return (
                        <option key={index} value={value.value}>
                          {value.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
          {/* </Row> */}
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">نام پزشک/پرستار :</label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : اصغر محمدی"
                onChange={(sampler_name) => {
                  updateSamplingData("sampler_name", sampler_name.target.value);
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">
              موبایل پزشک/پرستار :
            </label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : ۰۹۱۲۳۴۵۶۷۸۹"
                onChange={(sampler_contact_phone) => {
                  updateSamplingData(
                    "sampler_contact_phone",
                    sampler_contact_phone.target.value
                  );
                }}
              />
              <small className="text-muted">
                شماره پزشک/پرستار برای کاربر ارسال می‌شود. همچنین لوکیشن, آدرس و
                نوع خدمات برای پزشک/پرستار پیامک می‌شود.
              </small>
            </div>
          </div>
          <div
            className={
              isBrowser
                ? "form-group row sampling-order-action-buttons"
                : "form-group row sampling-order-action-buttons-mobile"
            }
          >
            <div className="col-sm-2"></div>
            <div className="col-sm-5">
              <CustomButton
                className="btn btn-small btn-success text-white full-width"
                action={submitSamplingData}
                content={"تایید و ارسال"}
                block={true}
                type={"success"}
                loading={add_sampling_data_waiting}
                textWhite={true}
              />
            </div>
            <div className="col-sm-5">
              <button
                className="btn btn-small btn-outline-black full-width"
                onClick={() => {
                  dispatch(closeHomeCareOrderSamplingModal());
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    </LargeModal>
  );
};

export default HomeCareSamplingComponent;
